import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CnpjCpfService {

    /** Remove a máscara do CNPJ/CPF informado */
    deformatar(cnpjCpf: string): string {
        if (!cnpjCpf || cnpjCpf == '') {
            return '';
        }
        return cnpjCpf.replace(/\.|\-|\/|\_/g, '');
    }

    /** Realiza a validação do CNPJ / CPF informado com base no tipo: 1 = Pessoa Física; 2 = Pessoa Jurídica */
    validar(tipo: number, cnpjCpf: string): boolean {
        if (!tipo) {
            tipo = 2; // Setando Pessoa Jurídica como padrão caso não informado o tipo
        }

        if (cnpjCpf) {
            let valor = cnpjCpf.replace(/\.|\-|\/|\_/g, '');

            // Se o valor for em branco, não valida. Simplemente retorna que está válido...
            if (valor === '') {
                return true;
            }

            if (tipo === 1) { // Pessoa Física
                if (valor.length < 11) {
                    return false;
                } else if (valor.length > 11) {
                    valor = valor.substring(0, 11);
                }
                return this.validarCpf(valor);
            } else if (tipo === 2) { // Pessoa Jurídica
                if (valor.length < 14) {
                    return false;
                } else if (valor.length > 14) {
                    valor = valor.substring(0, 14);
                }
                return this.validarCnpj(valor);
            } else { // Inválido
                return false;
            }
        }

        return true;
    }

    /** Função que realiza a validação do CPF */
    private validarCpf(cpf): boolean {
        let soma;
        let resto;
        let i;

        if ( (cpf.length !== 11) ||
        (cpf === '00000000000') || (cpf === '11111111111') ||
        (cpf === '22222222222') || (cpf === '33333333333') ||
        (cpf === '44444444444') || (cpf === '55555555555') ||
        (cpf === '66666666666') || (cpf === '77777777777') ||
        (cpf === '88888888888') || (cpf === '99999999999') ) {
            return false;
        }

        soma = 0;
        for (i = 1; i <= 9; i++) {
            soma += Math.floor(cpf.charAt(i - 1)) * (11 - i);
        }

        resto = 11 - (soma - (Math.floor(soma / 11) * 11));
        if ( (resto === 10) || (resto === 11) ) {
            resto = 0;
        }

        if ( resto !== Math.floor(cpf.charAt(9)) ) {
            return false;
        }

        soma = 0;
        for (i = 1; i <= 10; i++) {
            soma += cpf.charAt(i - 1) * (12 - i);
        }

        resto = 11 - (soma - (Math.floor(soma / 11) * 11));
        if ( (resto === 10) || (resto === 11) ) {
            resto = 0;
        }

        if (resto !== Math.floor(cpf.charAt(10)) ) {
            return false;
        }

        return true;
    }

    /** Função que realiza a validação do CNPJ */
    private validarCnpj(cnpj) {
        let i;
        const c  = cnpj.substr(0, 12);
        const dv = cnpj.substr(12, 2);
        let d1 = 0;

        for (i = 0; i < 12; i++) {
            d1 += c.charAt(11 - i) * (2 + (i % 8));
        }

        // eslint-disable-next-line eqeqeq
        if (d1 == 0) {
            return false;
        }

        d1 = 11 - (d1 % 11);

        if (d1 > 9) {
            d1 = 0;
        }

        // eslint-disable-next-line eqeqeq
        if (dv.charAt(0) != d1) {
            return false;
        }

        d1 *= 2;

        for (i = 0; i < 12; i++) {
            d1 += c.charAt(11 - i) * ( 2 + ((i + 1) % 8));
        }

        d1 = 11 - (d1 % 11);

        if (d1 > 9) {
            d1 = 0;
        }

        // eslint-disable-next-line eqeqeq
        if (dv.charAt(1) != d1) {
            return false;
        }

        return true;
    }

    /** Verifica se o CNPJ Raíz é válido */
    validarCnpjRaiz(cnpjRaiz: string): boolean {
        if (cnpjRaiz) {
            const valor = cnpjRaiz.replace(/\.|\-|\/|\_/g, '');
            // Se o valor for em branco, não valida. Simplemente retorna que está válido...
            if (valor === '') {
                return true;
            }

            if (valor.length !== 8) {
                return false;
            }
        }

        return true;
    }
}

